
import mapboxgl from 'mapbox-gl/dist/mapbox-gl.js'
import map from 'lodash/map'

export default {
    mapboxLoad(){
        if (!('remove' in Element.prototype)) {
            Element.prototype.remove = () => {
              if (this.parentNode) {
                  this.parentNode.removeChild(this)
              }
            }
        }

        const listings = document.querySelectorAll('.listings-sidebar__init')
        mapboxgl.accessToken = 'pk.eyJ1Ijoidml0YWxhZ2VuY3kiLCJhIjoiY2pzeXMxdHh2MHplcjQ0b2YwdjZqc2ljeSJ9.ocanScMc7nrOCDD8SLOIiA';
        const mapL = new mapboxgl.Map({
            container: 'map-locations',
            style: 'mapbox://styles/vitalagency/ckny9u02w3txe17oakj403x5h',
            center: [-7.1454367,54.3137209],
            zoom: 3,
            scrollZoom: false,
        })



        const geojson = {
            'type': 'FeatureCollection',
            'features': [],
        }
        map(JSON.parse($('#map-locations').attr('data-map')), item => {
            if(item.location){
                let dataItem = {
                    type: 'Feature',
                    geometry: {
                        type: 'Point',
                        coordinates: [Number(item.location.longitude), Number(item.location.latitude)],
                    },
                    properties: {
                        title: item.title,
                    },
                }
                if(item.branch_address){
                    dataItem.properties.branch_address = item.branch_address
                }
                if(item.mail_address){
                    dataItem.properties.mail_address = item.mail_address
                }
                if(item.image){
                    dataItem.properties.image = item.image
                }
                if(item.fax){
                    dataItem.properties.fax = item.fax
                }
                if(item.telephone){
                    dataItem.properties.telephone = item.telephone
                }

                if(item.email){
                    dataItem.properties.email = item.email
                }

                geojson.features.push(dataItem)

            }
        })



        let squarebox = {
            min: [999999999999999, 999999999999999],
            max: [-999999999999999, -999999999999999],
        }

        map(JSON.parse($('#map-locations').attr('data-map')), item => {
            if(item.location){
                if(Number(item.location.longitude) < squarebox.min[0]){
                    squarebox.min[0] = Number(item.location.longitude)
                }
                if(Number(item.location.latitude) < squarebox.min[1]){
                    squarebox.min[1] = Number(item.location.latitude)
                }
                if(Number(item.location.longitude) > squarebox.max[0]){
                    squarebox.max[0] = Number(item.location.longitude)
                }
                if(Number(item.location.latitude) > squarebox.max[1]){
                    squarebox.max[1] = Number(item.location.latitude)
                }

            }

        })
        const bbox = [
            [squarebox.min[0], squarebox.min[1]],
            [squarebox.max[0], squarebox.max[1]],
        ]


        mapL.on('load', () => {

                mapL.addSource('places', {
                  'type': 'geojson',
                  'data': geojson,
                })
                buildLocationList(geojson);

                fitMap(bbox)

                $(document.body).on('click', '.zoom-out', function(){
                    fitMap(bbox)
                    $(document.body).removeClass('map-active')
                })
                $(window).resize()
        })

        geojson.features.forEach(function(marker, i) {
            let el = document.createElement('div')
            el.id = 'marker-' + i
            el.className = 'marker'
            // Add markers to the map at all points
            new mapboxgl.Marker(el, {offset: [0, -23]})
                .setLngLat(marker.geometry.coordinates)
                .addTo(mapL)

            el.addEventListener('click', function(e){
                $(document.body).addClass('map-active')
                flyToStore(marker)

                const activeItem = document.getElementsByClassName('active')

                e.stopPropagation()
                if (activeItem[0]) {
                   activeItem[0].classList.remove('active')
                }

                const listing = document.getElementById('listing-' + i)
                listing.classList.add('active')


                // const scrollbar = Scrollbar.getAll()[0]
                // scrollbar.scrollTo(0, $('#listing-' + i).position().top, 600);

            })
        })

        function fitMap(box){
                mapL.fitBounds(box, {
                    padding: {
                        top: 50,
                        bottom: 50,
                        left: 50,
                        right: 50,
                    },
                })
        }


        function flyToStore(currentFeature) {
            mapL.flyTo({
                center: currentFeature.geometry.coordinates,
                zoom: 16,
                speed: 0.85,
                pitch: 55,
                bearing: -15,
            })
        }




        function buildLocationList(data) {

            for (let i = 0; i < data.features.length; i++) {
                let currentFeature = data.features[i];
                let prop = currentFeature.properties;


                let listing = listings[0].appendChild(document.createElement('div'));
                listing.className = 'listing-item';
                listing.id = 'listing-' + i;


                if(prop.image){
                    $('#listing-' + i).append('<div class="listing-item__image object-fix">' + prop.image + '</div>')
                }

                $('#listing-' + i).append('<div class="listing-item__content"></div>')

                $('#listing-' + i + ' .listing-item__content').append('<h3 class="font-semibold text-xl">' + prop.title + '</h3>')

                $('#listing-' + i + ' .listing-item__content').append('<div class="content block"></div>')

                if(prop.branch_address){
                    $('#listing-' + i + ' .content').append('<div class="mb-3 font-secondary text-sm leading-relaxed font-light"><div class="font-primary text-sm text-primary">Branch Address</div>' + prop.branch_address + '</div>')
                }

                if(prop.mail_address){
                    $('#listing-' + i + ' .content').append('<div class="mb-3 font-secondary text-sm leading-relaxed font-light"><div class="font-primary text-sm text-primary">Mail Address</div>' + prop.mail_address + '</div>')
                }

                if(prop.email){
                    $('#listing-' + i + ' .content').append('<div class="email"><span>e. </span><a class="border-b border-primary hover:border-black font-light" href="mailto:' + prop.email + '?subject=' + prop.title +' - Enquiry">' + prop.email + '</a></div>')
                }
                if(prop.telephone){
                    $('#listing-' + i + ' .content').append('<div class="telephone"><span>t. </span><a class="border-b border-primary hover:border-black font-light" href="tel:' + prop.telephone.replace(/\s/g, '') + '">' + prop.telephone + '</a></div>')
                }

                if(prop.fax){
                    $('#listing-' + i + ' .content').append('<div class="fax"><span>f. </span>' + prop.fax + '</div>')
                }





            }
            // Scrollbar.init(listings[0], { continuousScrolling: false })

        }

    },
    init(){
        this.mapboxLoad()
    },
};
